import React from 'react';
import styled from 'styled-components';
import { TableCell, TableRow, TextField, Autocomplete} from '@mui/material';

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`


const AMeditablerow = ({k,row, subCateg, handleCancelClick, tableFontSize,
   page, rowsPerPage, editFormData, onChangeEditCateg, SubmitButton}) =>{
    return( <>
        <TableRow key={k} name={row.categ}>
            <TableCell component="th" scope="row" align="left">
            {(page)*(rowsPerPage)+k+1}
            </TableCell>
           
        <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
          <TextField
            id="outlined-basic"
            size='small'
            type="text"
            name={'Category'}
            onChange={(e) => onChangeEditCateg(e, k, row._id)}
            label="Designation"
            value={editFormData[k]?.Category}
            variant="outlined"
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />     
        </TableCell>
        <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
          {subCateg[`subcateg${(page)*(rowsPerPage)+k}`]?.data?.length? <TextField
            id="outlined-basic"
            size='small'
            type="text"
            name={'Asset'}
            onChange={(e) => onChangeEditCateg(e, k, row._id)}
            label="Asset"
            value={editFormData[k]?.Asset[subCateg[`subcateg${(page)*(rowsPerPage)+k}`]?.index]?.Name}
            variant="outlined"
            sx={{backgroundColor:"white", width:"200px", height:"40px"}}
          />:"Select Asset"}
            </TableCell>
            <TableCell align="left">
              <ButtonWrapper>
                <SubmitButton type="submit">Save</SubmitButton>
                <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
              </ButtonWrapper>                        
            </TableCell>
          </TableRow>     
        </>         
    )
}

export default AMeditablerow;